var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as Headless from '@headlessui/react';
import clsx from 'clsx';
import { Text } from './text';
const sizes = {
    xs: 'sm:max-w-xs',
    sm: 'sm:max-w-sm',
    md: 'sm:max-w-md',
    lg: 'sm:max-w-lg',
    xl: 'sm:max-w-xl',
    '2xl': 'sm:max-w-2xl',
    '3xl': 'sm:max-w-3xl',
    '4xl': 'sm:max-w-4xl',
    '5xl': 'sm:max-w-5xl'
};
export function Alert(_a) {
    var { open, onClose, size = 'md', className, children } = _a, props = __rest(_a, ["open", "onClose", "size", "className", "children"]);
    return (_jsx(Headless.Transition, Object.assign({ appear: true, show: open }, props, { children: _jsxs(Headless.Dialog, { onClose: onClose, children: [_jsx(Headless.TransitionChild, { enter: "ease-out duration-100", enterFrom: "opacity-0", enterTo: "opacity-100", leave: "ease-in duration-100", leaveFrom: "opacity-100", leaveTo: "opacity-0", children: _jsx("div", { className: "fixed inset-0 flex w-screen justify-center overflow-y-auto bg-zinc-950/15 px-2 py-2 focus:outline-0 sm:px-6 sm:py-8 lg:px-8 lg:py-16 dark:bg-zinc-950/50" }) }), _jsx("div", { className: "fixed inset-0 w-screen overflow-y-auto pt-6 sm:pt-0", children: _jsx("div", { className: "grid min-h-full grid-rows-[1fr_auto_1fr] justify-items-center p-8 sm:grid-rows-[1fr_auto_3fr] sm:p-4", children: _jsx(Headless.TransitionChild, { enter: "ease-out duration-100", enterFrom: "opacity-0 scale-95", enterTo: "opacity-100 scale-100", leave: "ease-in duration-100", leaveFrom: "opacity-100", leaveTo: "opacity-0", children: _jsx(Headless.DialogPanel, { className: clsx(className, sizes[size], 'row-start-2 w-full rounded-2xl bg-white p-8 shadow-lg ring-1 ring-zinc-950/10 sm:rounded-2xl sm:p-6 dark:bg-zinc-900 dark:ring-white/10 forced-colors:outline'), children: children }) }) }) })] }) })));
}
export function AlertTitle(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (_jsx(Headless.DialogTitle, Object.assign({}, props, { className: clsx(className, 'text-balance text-center text-base/6 font-semibold text-zinc-950 sm:text-wrap sm:text-left sm:text-sm/6 dark:text-white') })));
}
export function AlertDescription(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (_jsx(Headless.Description, Object.assign({ as: Text }, props, { className: clsx(className, 'mt-2 text-pretty text-center sm:text-left') })));
}
export function AlertBody(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return _jsx("div", Object.assign({}, props, { className: clsx(className, 'mt-4') }));
}
export function AlertActions(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (_jsx("div", Object.assign({}, props, { className: clsx(className, 'mt-6 flex flex-col-reverse items-center justify-end gap-3 *:w-full sm:mt-4 sm:flex-row sm:*:w-auto') })));
}
